import { render, staticRenderFns } from "./login-malaysia.vue?vue&type=template&id=91387354&scoped=true&"
import script from "./login-malaysia.vue?vue&type=script&lang=ts&"
export * from "./login-malaysia.vue?vue&type=script&lang=ts&"
import style0 from "./login-malaysia.vue?vue&type=style&index=0&id=91387354&prod&lang=scss&scoped=true&"
import style1 from "./login-malaysia.vue?vue&type=style&index=1&id=91387354&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91387354",
  null
  
)

export default component.exports